<template>
	<div
		class="p-5 rounded border"
		:class="{
    'bg-white text-qwr-dark-600 border-white': variant === 'default',
    'text-error-800 bg-error-100 border-error-200': variant === 'error',
    'text-notice-800 bg-notice-100 border-notice-200': variant === 'notice',
  }"
	>
		<slot />
	</div>
</template>

<script lang="ts" setup>
export interface Props {
  variant?: 'default' | 'error' | 'notice'
}

withDefaults(defineProps<Props>(), {
  variant: 'default',
});
</script>
